
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elearning/[exam_slug]",
      function () {
        return require("private-next-pages/elearning/[exam_slug]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elearning/[exam_slug]"])
      });
    }
  